import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-024ab4a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-col-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "wrap-col-header__title pt-3 xl:pt-0" }, "Resumen de obligaciones", -1))
const _hoisted_3 = { class: "wrap-col-header__data-update" }
const _hoisted_4 = { class: "flex flex-col content-start" }
const _hoisted_5 = {
  key: 0,
  class: "text-xs md:text-sm font-semibold text-primary flex items-center justify-center bg-white shadow-md rounded-lg h-32 p-3"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Actualmente no cuenta con obligaciones activas disponibles", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = {
  href: "",
  ref: "iPhoneLink",
  rel: "noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_NegotiationCard = _resolveComponent("NegotiationCard")!
  const _component_ObligationCard = _resolveComponent("ObligationCard")!
  const _component_AgreementCard = _resolveComponent("AgreementCard")!
  const _component_LinceObligationCard = _resolveComponent("LinceObligationCard")!
  const _component_DannRegionalCard = _resolveComponent("DannRegionalCard")!
  const _component_ModalNegotiation = _resolveComponent("ModalNegotiation")!
  const _component_ModalGratitude = _resolveComponent("ModalGratitude")!
  const _component_ModalDetails = _resolveComponent("ModalDetails")!
  const _component_ModalClientDanRegional = _resolveComponent("ModalClientDanRegional")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, " Última actualización " + _toDisplayString(_ctx.$filters.formatDate(_ctx.timestamp)), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.countObligations() && !_ctx.isLoadingObligations)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : _createCommentVNode("", true),
      _createVNode(_component_Loader, { showLoader: _ctx.isLoadingObligations }, null, 8, ["showLoader"]),
      _createVNode(_component_NegotiationCard, {
        negotiations: _ctx.negotiations_,
        "is-loading-payment-status": _ctx.isLoadingPaymentStatus,
        onViewDetailPlan: _ctx.viewDetailPlan,
        onMakePayment: _ctx.makePayment
      }, null, 8, ["negotiations", "is-loading-payment-status", "onViewDetailPlan", "onMakePayment"]),
      _createVNode(_component_ObligationCard, {
        "obligations-by-portfolio": _ctx.filterPortfolios,
        onNegotiation: _ctx.negotiation
      }, null, 8, ["obligations-by-portfolio", "onNegotiation"]),
      _createVNode(_component_AgreementCard, {
        agreements: _ctx.agreements_,
        "is-loading-payment-status": _ctx.isLoadingPaymentStatus,
        onViewDetailPlan: _ctx.viewDetailPlan,
        onMakePayment: _ctx.makePayment
      }, null, 8, ["agreements", "is-loading-payment-status", "onViewDetailPlan", "onMakePayment"]),
      _createVNode(_component_LinceObligationCard, {
        "lince-obligations": _ctx.openLinceObligations,
        "is-loading-payment-status": _ctx.isLoadingPaymentStatus,
        onViewDetailPlan: _ctx.viewDetailPlan,
        onMakePayment: _ctx.makePayment
      }, null, 8, ["lince-obligations", "is-loading-payment-status", "onViewDetailPlan", "onMakePayment"]),
      _createVNode(_component_DannRegionalCard, {
        "repository-obligations": _ctx.openRepositoryObligations,
        "is-loading-payment-status": _ctx.isLoadingPaymentStatus,
        onViewDetailPlan: _ctx.viewDetailPlan,
        onMakePayment: _ctx.makePayment
      }, null, 8, ["repository-obligations", "is-loading-payment-status", "onViewDetailPlan", "onMakePayment"]),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_component_ModalNegotiation, {
          portfolio: _ctx.portfolioSelected,
          "is-visible": _ctx.showModal,
          onClose: _ctx.closeModal,
          onOpenModalGratitude: _ctx.openModalGratitude
        }, null, 8, ["portfolio", "is-visible", "onClose", "onOpenModalGratitude"]),
        _createVNode(_component_ModalGratitude, {
          "is-visible": _ctx.showModalGratitude,
          "saved-negotiation-id": _ctx.savedNegotiationId,
          onClose: _ctx.closeModalGratitude
        }, null, 8, ["is-visible", "saved-negotiation-id", "onClose"]),
        _createVNode(_component_ModalDetails, {
          "pay-plan": _ctx.payPlan,
          "payment-detail": _ctx.paymentDetail,
          "is-visible": _ctx.showModalDetails,
          "loading-quota-summary": _ctx.loadingQuotaSummary,
          "is-loading-payment-status": _ctx.isLoadingPaymentStatus,
          onClose: _ctx.closeModal
        }, null, 8, ["pay-plan", "payment-detail", "is-visible", "loading-quota-summary", "is-loading-payment-status", "onClose"]),
        _createVNode(_component_ModalClientDanRegional, {
          "is-visible": 
          _ctx.isDannRegional && _ctx.showModalDanRegional && _ctx.viewModalFondeadores
        ,
          onClose: _ctx.closeModalDanRegional
        }, null, 8, ["is-visible", "onClose"])
      ])),
      _hoisted_8
    ]),
    _createElementVNode("a", _hoisted_9, null, 512)
  ], 64))
}